import { render, staticRenderFns } from "./GamesGrid.vue?vue&type=template&id=6115be2f&scoped=true&"
import script from "./GamesGrid.vue?vue&type=script&lang=ts&"
export * from "./GamesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./GamesGrid.vue?vue&type=style&index=0&id=6115be2f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6115be2f",
  null
  
)

export default component.exports